import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef, Ref, ref } from 'vue';
import { RouteLocationRaw } from 'vue-router';

import PopupMenu, { PopupMenuApi } from '@/components/dialogs/popupmenu/PopupMenu.vue';
import { useNotifications } from '@/composables/notification/Notifications';
import { Notification } from '@/data/datatypes/Notification';
import NotificationNavListItem from '@/navigation/NotificationNavListItem.vue';
import RouteNames from '@/router/RouteNames';

interface Props {
  above?: boolean;
}
interface Emits {
  (e: 'close'): void,
  (e: 'clearAllNotifications'): void,
  (e: 'notificationClicked'): void,
  (e: 'notificationDeleted'): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsPopup',
  props: {
    above: { type: Boolean, default: false }
  },
  emits: ["close", "clearAllNotifications", "notificationClicked", "notificationDeleted"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void,
  (e: 'clearAllNotifications'): void,
  (e: 'notificationClicked'): void,
  (e: 'notificationDeleted'): void,
}), expose: any, slots: any, attrs: any }) {

const { allNotifications } = useNotifications();





const popupMenu: Ref<PopupMenuApi | null> = ref(null);

const notificationsRoute: ComputedRef<RouteLocationRaw> = computed(() => {
  return {
    name: RouteNames.NOTIFICATIONS_ROUTE_NAME
  };
});

function close(): void {
  // It is necessary to close the popupMenu manually as it has been populated via slots
  popupMenu.value?.close();
  emit('close');
}

function removeAllConfirm(): void {
  // clear all notifications
  close();
  emit('clearAllNotifications');
}

function notificationClicked(): void {
  // notify clicked
  close();
  emit('notificationClicked');
}

function notificationDeleted(notification: Notification): void {
  if (notification.deleteHandler) {
    notification.deleteHandler();
  }
  emit('notificationDeleted');
}

return { __sfc: true,allNotifications, emit, popupMenu, notificationsRoute, close, removeAllConfirm, notificationClicked, notificationDeleted, PopupMenu, NotificationNavListItem }
}

})